import React from "react";

function Portfolio() {
  return (
    <section
      id="projects"
      className="py-20 bg-white dark:bg-gray-900 text-center"
    >
      <h2 className="text-4xl font-bold mb-12 dark:text-white">
        My Projects
      </h2>

      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8 px-6">

        {/* Job Portal */}
        <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition duration-300">

          <h3 className="text-2xl font-bold dark:text-white">
            Job Portal
          </h3>

          <p className="mt-3 text-gray-700 dark:text-gray-300">
            A modern responsive job portal that provides the latest Government
            and Private job notifications, eligibility, important dates,
            application links, and complete recruitment details.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mt-4">
            <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
              Next.js 14
            </span>

            <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
              Python scraper
            </span>

            <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-sm">
              Google AdSense
            </span>

            <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-sm">
              Supabase
            </span>
          </div>

          <div className="flex justify-center gap-3 mt-6">

            <a
              href="https://jobportal-topaz-nine.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg transition"
            >
              Live Demo
            </a>

            <a
              href="https://github.com/gadge-786/jobportal"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-800 hover:bg-black text-white px-5 py-2 rounded-lg transition"
            >
              GitHub
            </a>

          </div>

        </div>

        {/* Business Landing Page */}

        <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition duration-300">

          <h3 className="text-2xl font-bold dark:text-white">
            Phano is an aesthetic social commerce and visual discovery platform
          </h3>

          <p className="mt-3 text-gray-700 dark:text-gray-300">
            Phano is an aesthetic social commerce and visual discovery platform. It seamlessly bridges 
            the gap between lifestyle content creation and instant e-commerce, allowing users to discover 
            curated lifestyle inspiration and purchase the exact items featured in posts with a single tap.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mt-4">

            <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
              React 18 with TypeScript
            </span>

            <span className="bg-cyan-100 text-cyan-700 px-3 py-1 rounded-full text-sm">
              motion/react
            </span>

            <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-sm">
              PostgreSQL
            </span>

            <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-sm">
              Multimodal AI Engine
            </span>

          </div>

          <div className="flex justify-center gap-3 mt-6">

            <a
              href="https://de-ma-xi.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg transition"
            >
              Live Demo
            </a>

            <a
              href="https://github.com/gadge-786/De-ma"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-800 hover:bg-black text-white px-5 py-2 rounded-lg transition"
            >
              GitHub
            </a>

          </div>

        </div>

        {/* More Projects */}

        <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow-lg border-2 border-dashed border-gray-400 hover:shadow-2xl hover:-translate-y-2 transition duration-300">

          <h3 className="text-2xl font-bold dark:text-white">
            More Projects Coming Soon
          </h3>

          <p className="mt-3 text-gray-700 dark:text-gray-300">
            I am continuously building modern web applications using React,
            Django, Python, SQL, and other technologies. More exciting
            projects will be added here soon.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mt-4">

            <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
              React
            </span>

            <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
              Django
            </span>

            <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-sm">
              Python
            </span>

            <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm">
              SQL
            </span>

          </div>

        </div>

      </div>
    </section>
  );
}

export default Portfolio;